export default __webpack_public_path__ + "static/media/java.5d5cffa0.png";